import DOCUMENTATION_PRODUCT_NAME, {
    PAGE_PRODUCT,
    recordEvent,
    recordEventCustomOnly,
    recordEventStepSuccess,
    recordPage,
    RELIABLE,
} from 'utilities/uTagging';
import { TGSS_RADIO_VALUES } from './constants';
import { PATH_DOCUMENTATION } from 'constants/uTagConstants/paths';
import { DOCUMENT_TYPES } from 'constants/documents';
import cryptoJS from 'crypto-js';
import { getGA4EventKeys } from 'utilities/ga4';

export const doTagQRDocumentationView = ({
    identityMethod,
    jointHolderInfo,
    investmentType,
    product,
    promoCode,
    recordId,
    userId,
    isDocumentRetryBeenShown,
    onboardingOrigin,
    docNumber,
    clientRisk,
}) => {
    const pageName = isDocumentRetryBeenShown
        ? '/onboarding/step8/documentationQR_review'
        : '/onboarding/step8/documentationQR';

    recordPage(
        pageName,
        recordId,
        userId,
        product,
        '',
        promoCode ? promoCode : '',
        jointHolderInfo,
        '',
        '',
        investmentType,
        {
            ...getGA4EventKeys({
                eventName: 'step_documentation',
                pageName,
                processDetail: isDocumentRetryBeenShown ? 'documentationQR_review' : 'documentationQR',
                onboardingType: investmentType,
                typeHolder: jointHolderInfo.typeHolder,
            }),
            processStep: 'step8',
            onboardingOrigin,
            onboardingR: clientRisk || '',
            onboardingIdMethod: RELIABLE[identityMethod],
            identificadorOnboarding: docNumber ? cryptoJS.SHA256(docNumber).toString() : '',
        }
    );

    return pageName;
};

export const documentTypeToTaggingNames = docTypes => {
    const validTypes = {
        [DOCUMENT_TYPES.DNI_FRONT]: 'frente dni',
        [DOCUMENT_TYPES.DNI_BACK]: 'dorso dni',
        [DOCUMENT_TYPES.NIE_FRONT]: 'frente cue',
        [DOCUMENT_TYPES.PASSPORT_FRONT]: 'frente pasaporte',
        [DOCUMENT_TYPES.PASSPORT_BACK]: 'dorso pasaporte',
        [DOCUMENT_TYPES.PERMIT_FRONT]: 'frente nie',
        [DOCUMENT_TYPES.PERMIT_BACK]: 'dorso nie',
        [DOCUMENT_TYPES.DAAL]: 'documento de ingresos',
        [DOCUMENT_TYPES.RECIBO_TRANSFERENCIA]: 'verificación de domicilio',
    };

    return docTypes.map(id => validTypes[id]).join(',');
};

export const doTagRadioConsent = () =>
    recordEventCustomOnly({
        categoriaEvento: 'eventos onboarding',
        accionEvento: 'clickRadioButton',
        etiquetaEvento: 'autorizar consulta TGSS',
    });

export const doTagRadioUpload = () =>
    recordEventCustomOnly({
        categoriaEvento: 'eventos onboarding',
        accionEvento: 'clickRadioButton',
        etiquetaEvento: 'subir DAAL',
    });

export const doTagFinishStepSuccess = userProfile =>
    recordEventStepSuccess(userProfile.investmentType, '/onboarding/step8/documentationqr', 'subida de documentos', {
        event_name: 'event_success',
        action: 'success',
        format: 'steps',
        component: 'funnel',
        element: 'documentationVedacom',
    });

export const doTagDocumentUpload = (userProfile, docTitle, error) =>
    recordEvent(
        PATH_DOCUMENTATION,
        PAGE_PRODUCT,
        'subir documento',
        `subir documento ${docTitle} ${error ? 'incorrecto' : 'correcto'}`,
        userProfile.recordId,
        userProfile.userId,
        RELIABLE[userProfile.identityMethod],
        userProfile.investmentType,
        {
            nombreProducto: DOCUMENTATION_PRODUCT_NAME,
        }
    );

export const doTagOnFileReceived = docId =>
    recordEventCustomOnly({
        categoriaEvento: 'eventos onboarding',
        accionEvento: 'exito subida de documentacion',
        etiquetaEvento: `foto ${documentTypeToTaggingNames([docId])}`,
    });

export const doTagOnRequestUpload = (userProfile, isDocumentRetryBeenShown) => {
    const accionEvento = isDocumentRetryBeenShown ? '/onboarding/documentacion/revision' : '/onboarding/documentacion/';
    recordEventStepSuccess(userProfile.investmentType, accionEvento, 'subida de documentos', {
        event_name: 'event_success',
        action: 'success',
        format: 'service',
        component: 'funnel',
        element: 'documentation',
    });
};

export const doTagOnExit = () =>
    recordEventCustomOnly({
        accionEvento: 'salir',
        categoriaEvento: 'interaccion en documentacion',
    });

export const doTagOnTgssExit = () =>
    recordEventCustomOnly({
        categoriaEvento: 'eventos onboarding',
        accionEvento: 'clickLink',
        etiquetaEvento: 'salir',
    });

export const doTagOnFinalize = () =>
    recordEventCustomOnly({
        accionEvento: 'documentacion',
        etiquetaEvento: 'finalizar',
        categoriaEvento: 'eventos onboarding',
    });

export const doTagOnTgssFinalize = userProfile =>
    recordEventCustomOnly({
        categoriaEvento: 'eventos onboarding',
        accionEvento: 'clickButton',
        etiquetaEvento: `continuar/${
            userProfile.documentationTgssConsent === TGSS_RADIO_VALUES.CONSENT ? 'autorizar' : 'subir'
        }`,
    });
